import React from 'react'
import { Modal } from 'antd'

import ReadyToOrderFreightForm from '../../../components/Purchasing/Order/ReadyToOrderFreightForm'
import FooterButtons from '../../../elements/Buttons/FooterButtons'

function CreateFreightModal(props) {
  const { visible, submitting, submit, formRef, onCancel, isNew } = props

  return (
    <Modal
      visible={visible}
      title={'Create Freight'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={<FooterButtons submit={submit} submitting={submitting} title={'Create Freight'} isNew={isNew} />}
      width={'75%'}>
      <ReadyToOrderFreightForm ref={formRef} {...props} />
    </Modal>
  )
}

export default CreateFreightModal
